import * as React from "react";
import { CheckboxWithLabel } from "@grandvisionhq/forms";
/* empty css          */
const Fake = ({ details, label, onChange }) => {
  const initialState = details && typeof details.alwaysFail === "boolean" ? details.alwaysFail : false;
  const [isChecked, setIsChecked] = React.useState(initialState);
  const convertStateToPaymentDetails = (state) => ({
    alwaysFail: state
  });
  const handleOnChange = ({ checked }) => {
    setIsChecked(checked);
    onChange(convertStateToPaymentDetails(checked), true);
  };
  React.useEffect(() => {
    if (!details) {
      onChange(convertStateToPaymentDetails(isChecked), true);
    }
  }, [details, isChecked, onChange]);
  return /* @__PURE__ */ React.createElement(
    CheckboxWithLabel,
    {
      className: "fake-payment ",
      id: "fakePayment",
      value: "fail",
      checked: isChecked,
      onChange: handleOnChange,
      label: label || "🧨 Fail to register payment"
    }
  );
};
export {
  Fake
};
//# sourceMappingURL=Fake.js.map
